import _extends from "@babel/runtime/helpers/esm/extends";
const coreBlue = {
  900: '#03060d',
  // $color-core-blue-01-dark
  800: '#00205b',
  // $color-core-blue
  700: '#093582',
  // $color-core-blue-03-light
  600: '#1c4ea5',
  // $color-core-blue-04-light
  500: '#3a6cc1',
  // $color-core-blue-05-light
  400: '#628dd6',
  // $color-core-blue-06-light
  300: '#8eafe6',
  // $color-core-blue-07-light
  200: '#b7ccf0',
  // $color-core-blue-08-light
  100: '#d6e2f7',
  // $color-core-blue-09-light
  50: '#ebf0fa',
  //  $color-core-blue-10-light
  25: '#f6f7fa' //  $color-core-blue-11-light
};

const primary = _extends({}, coreBlue, {
  dark: coreBlue[900],
  //  $$color-core-blue-01-dark
  main: coreBlue[800],
  //  $color-core-blue
  light: coreBlue[700],
  // $color-core-blue-03-light
  contrastText: '#ffffff'
});
export default primary;